import { type RulesLogic } from "json-logic-js";
import { cloneDeep } from "lodash";
import {
  type Config as ConfigType,
  type ImmutableTree,
  Utils as QbUtils,
} from "react-awesome-query-builder";

import BasicConfig from "@components/raqb-bootstrap/config";

export const ADVANCED_SEARCH_EDITOR_CONFIG: Readonly<ConfigType> = {
  ...BasicConfig,
  settings: {
    ...BasicConfig.settings,
    showNot: false,
    valueSourcesInfo: {
      value: {
        label: "Value",
      },
    },
  },
  fields: {
    campaignName: { type: "text", label: "Campaign Name" },
    adsetName: { type: "text", label: "Adset Name" },
    adName: { type: "text", label: "Ad Name" },
    landingPage: { type: "text", label: "URL" },
  },
} as any;

const DEFAULT_RULE = {
  and: [
    {
      "==": [
        {
          var: "campaignName",
        },
        "",
      ],
    },
  ],
};

export function getDefaultRule(): any {
  return cloneDeep(DEFAULT_RULE);
}

export function searchTreeToJsonLogic(tree: ImmutableTree): RulesLogic {
  return QbUtils.jsonLogicFormat(tree, ADVANCED_SEARCH_EDITOR_CONFIG)
    .logic! as RulesLogic;
}

export function jsonLogicToSearchTree(jsonLogic: RulesLogic): ImmutableTree {
  return QbUtils.loadFromJsonLogic(jsonLogic, ADVANCED_SEARCH_EDITOR_CONFIG);
}
